import React from "react"
import { 
  StyledTabletArticleNavigationWrapper,
  StyledTabletArticleNavigationTitle,
  StyledTabletArticleNavigationContainer,
  StyledTabletArticleNavigationItem
} from "./styled";

const TabletArticleNavigation = ({ articleTopics, setSelectedItem }) => {
  return (
    <StyledTabletArticleNavigationWrapper>
      <StyledTabletArticleNavigationTitle>In this guide, you’ll learn:</StyledTabletArticleNavigationTitle>
      <StyledTabletArticleNavigationContainer>
        {articleTopics.map(({ innerText }, index) => (
          <StyledTabletArticleNavigationItem
            id={`article-section-h2-${index}`}
            onClick={() => setSelectedItem(`article-section-h2-${index}`)}
          >
            {innerText}
          </StyledTabletArticleNavigationItem>
        ))}
      </StyledTabletArticleNavigationContainer>
    </StyledTabletArticleNavigationWrapper>
  )
}

export default TabletArticleNavigation
